import styled from 'styled-components';

type FieldsetProps = {
  $isColumn: boolean;
};

export const Fieldset = styled.fieldset<FieldsetProps>`
  display: flex;
  margin: 0;
  padding: 0;
  border: 0;
  flex-direction: ${({ $isColumn }) => ($isColumn ? 'column' : 'row')};
  gap: ${({ $isColumn }) => ($isColumn ? '20px' : '0px')};
`;

export const Legend = styled.legend`
  ${({ theme }) => `
  font-size: 16px;
  font-weight: 900;
  line-height: 24px;
  color: ${theme.colors.textPrimarySecondary1100};
  margin-bottom: 16px;
`}
`;
